// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__38B1y","col":"CardReaderDesc_col__3YXkF","label":"CardReaderDesc_label__3eLxf"};